import React from "react";
import { useState, useEffect } from "react";
import { getDatabase, onValue, ref, set as firebaseSet } from 'firebase/database';

export function ToDo(props) {
    const [newTask, setNewTask] = useState("");
    const [userInput, setUserInput] = useState(null);
    const [toDoStatus, setToDoStatus] = useState([]);

    useEffect(() => {
        const db = getDatabase();
        const currentDate = new Date(Date.now());
        const userDayRef = ref(db, "todo/" + props.uid);
        const offFunction = onValue(userDayRef, (snapshot) => {
          // console.log("task ", snapshot);
          const newValue = snapshot.hasChild(currentDate.toDateString());
          // console.log(newValue);
          if(newValue) {
            const userDayRefInfo = ref(db, "todo/" + props.uid + '/' + currentDate.toDateString());
            const dayInfoOffFunction = onValue(userDayRefInfo, (snapshot) => {
              setToDoStatus(snapshot.val());
              // console.log(snapshot.val());
            })
            dayInfoOffFunction();
          } else {
            const userDayRefInfo = ref(db, "todo/" + props.uid + '/' + currentDate.toDateString());
            firebaseSet(userDayRefInfo, []);
            setToDoStatus([]);
          }
        })
        function cleanup() {
          offFunction();
        }
        return cleanup;
      }, [])

    function handleChange(event) {
        setUserInput(event.target.value);
    }

    function handleDelete(event) {
        event.preventDefault();
        const today = new Date(Date.now())
        const db = getDatabase();
        const taskString = "todo/" + props.uid + '/' + today.toDateString();
        const taskRef = ref(db, taskString);
        firebaseSet(taskRef, []);
        setToDoStatus([]);
    }

    function SubmitToDo(event) {
        event.preventDefault();
        if (userInput === "" || userInput === null) {
            props.setAlertMessage("No task specified!");
        } else {
            setNewTask(userInput);
            const taskToAdd = { id: ('todo-' + userInput), name: userInput, completed: false };
            const newTaskList = [...toDoStatus, taskToAdd];
            const today = new Date(Date.now())
            const db = getDatabase();
            const taskString = "todo/" + props.uid + '/' + today.toDateString();
            const taskRef = ref(db, taskString);
            firebaseSet(taskRef, newTaskList);
            setUserInput("");
        }
    }

    function CreateTaskList( {tasks, currentButton} ) {
        let taskList = tasks.map(task => {
            return <CreateTask tasks = {task} key = {task.name} />;
        });
        return (
            <ul className = "todo-list">
                {taskList}
            </ul>
        );
    }

    function CreateTask(props) {
        return (
            <div className="checklist-item">
                <li>
                    <input id={props.tasks.id} type="checkbox" className="check" />
                    {props.tasks.name}
                </li>
            </div>
        );
    }

    return (
        <div className="todo-area">
            <details className="drop-down">
            <summary><img src="img/todo.png" className="small-icon" alt="Checklist Icon" />To-Do List</summary>
            <form id="todo-form">
                <label htmlFor="todo-add">Enter tasks to add: </label>
                <input className="textInput" autoComplete="off" name="todo-add" onChange={handleChange}/>
                <button type="submit" className="add-to-list" onClick={SubmitToDo} aria-label="Submits to-do form">⨁ Add</button>
                <button  className="add-to-list" onClick={handleDelete} aria-label="Clears to-do form"><img src="img/trash.png" className="trash" alt="trash can"/>Clear All</button>
            </form>
                <CreateTaskList tasks = {toDoStatus} />
            </details>
        </div>
    );
}



